import { alpha, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { NAVY, SHADOW as NAVY_SHADOW, SURFACE_CONTAINER_LOWEST, YELLOW } from 'styles/tokens';

export { NAVY, NAVY_SHADOW, SURFACE_CONTAINER_LOWEST, YELLOW };

export const getNavItemButtonSx = (isActive: boolean, collapsed: boolean) => ({
  height: '38px',
  color: NAVY,
  backgroundColor: isActive ? YELLOW : 'transparent',
  paddingLeft: collapsed ? 0 : '16px',
  paddingRight: collapsed ? 0 : '16px',
  borderRadius: '24px',
  margin: '1px 0',
  justifyContent: collapsed ? 'center' : 'flex-start',
  boxShadow: isActive ? `0 4px 8px ${alpha(YELLOW, 0.25)}` : 'none',
  transition: 'all 0.46s cubic-bezier(0.25, 0.8, 0.25, 1)',
  '& .MuiListItemIcon-root': {
    minWidth: collapsed ? 'auto' : '36px',
    color: isActive ? NAVY : alpha(NAVY, 0.55),
    transition: 'all 0.46s cubic-bezier(0.25, 0.8, 0.25, 1)',
  },
  '& .MuiListItemText-root': {
    overflow: 'hidden',
    maxWidth: collapsed ? 0 : 180,
    opacity: collapsed ? 0 : 1,
    marginLeft: collapsed ? 0 : 2,
    transition: 'max-width 0.46s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.3s ease, margin-left 0.46s ease',
  },
  '& .MuiListItemText-primary': {
    fontSize: '14px',
    fontWeight: isActive ? 600 : 500,
    whiteSpace: 'nowrap',
  },
  '&:hover': isActive
    ? { backgroundColor: alpha(YELLOW, 0.85) }
    : {
        backgroundColor: alpha(NAVY, 0.06),
        color: NAVY,
        '& .MuiListItemIcon-root': { color: NAVY },
      },
});

export const GroupLabel = styled(Typography)(() => ({
  fontSize: '10px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: alpha(NAVY, 0.5),
  padding: '0 8px',
  marginBottom: '2px',
  marginTop: '10px',
}));

export const glassMenuProps = {
  sx: {
    '& .MuiPaper-root': {
      backdropFilter: 'blur(16px)',
      backgroundColor: 'rgba(249, 250, 253, 0.85)',
      boxShadow: NAVY_SHADOW,
      borderRadius: '16px',
      border: `1px solid ${alpha(NAVY, 0.06)}`,
    },
  },
} as const;
